import { SchedulingRuleTable } from 'components/table/scheduling_rules/Table';

export const ScheduleRules = () => {
    return (
        <>
            <SchedulingRuleTable />
        </>
    );
};
